export enum SyncAndPositionStatus {
	OpenSync = 'open_sync',
	OpenNotSync = 'open_not_sync',
	CloseSync = 'close_sync',
	CloseNotSync = 'close_not_sync',
	Trip = 'trip'	
}
